var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-container transition-all duration-100",style:(_vm.styles)},[_vm._t("default"),_vm._v(" "),(_vm.rulers && _vm.$root.showMoveHint)?_c('div',{attrs:{"id":"move-hint"}},[_vm._v("\n    Wist je dat je de kaart kan bewegen?\n  ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }